<template lang="pug">
component.link(
  v-bind="$attrs"
  :is="props.isCurrent ? 'span' : 'nuxt-link'"
  :to="props.isCurrent ? undefined : props.link"
  :aria-current="props.isCurrent ? 'page' : undefined"
  :class="{ 'is-current': props.isCurrent }"
)
  span(v-if="props.text") {{ props.text }}
  slot
</template>

<script setup lang="ts">
import { type BreadcrumbPatternProps } from './BreadcrumbPattern.types';
import { breadcrumbPatternDefaults } from './BreadcrumbPattern.defaults';

const props = withDefaults(
  defineProps<BreadcrumbPatternProps>(),
  breadcrumbPatternDefaults as any,
) as unknown as BreadcrumbPatternProps;
</script>
